import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

function BarcodeCode128Svg({ style = {width: "300px", height: "180px"}, color = "primary", viewBox = "0 0 1662.000000 220.000000" }) {
    return (
        <SvgIcon color={color} style={style} viewBox={viewBox}>
            <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path d="M250 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M370 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M500 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M700 1315 l0 -885 25 0 25 0 0 885 0 885 -25 0 -25 0 0 -885z"/>
                <path d="M870 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M1040 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M1160 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M1290 1315 l0 -885 60 0 60 0 0 885 0 885 -60 0 -60 0 0 -885z"/>
                <path d="M1450 1315 l0 -885 45 0 45 0 0 885 0 885 -45 0 -45 0 0 -885z"/>
                <path d="M1620 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M1750 1315 l0 -885 60 0 60 0 0 885 0 885 -60 0 -60 0 0 -885z"/>
                <path d="M1950 1315 l0 -885 45 0 45 0 0 885 0 885 -45 0 -45 0 0 -885z"/>
                <path d="M2080 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M2250 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M2370 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M2540 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M2620 1315 l0 -885 65 0 65 0 0 885 0 885 -65 0 -65 0 0 -885z"/>
                <path d="M2790 1315 l0 -885 80 0 80 0 0 885 0 885 -80 0 -80 0 0 -885z"/>
                <path d="M3000 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M3120 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M3290 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M3450 1315 l0 -885 45 0 45 0 0 885 0 885 -45 0 -45 0 0 -885z"/>
                <path d="M3620 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M3830 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M3910 1315 l0 -885 45 0 45 0 0 885 0 885 -45 0 -45 0 0 -885z"/>
                <path d="M4120 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M4290 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M4370 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M4580 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M4750 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M4830 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M4910 1315 l0 -885 65 0 65 0 0 885 0 885 -65 0 -65 0 0 -885z"/>
                <path d="M5080 1315 l0 -885 85 0 85 0 0 885 0 885 -85 0 -85 0 0 -885z"/>
                <path d="M5290 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M5370 1315 l0 -885 65 0 65 0 0 885 0 885 -65 0 -65 0 0 -885z"/>
                <path d="M5540 1315 l0 -885 80 0 80 0 0 885 0 885 -80 0 -80 0 0 -885z"/>
                <path d="M5750 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M5830 1315 l0 -885 85 0 85 0 0 885 0 885 -85 0 -85 0 0 -885z"/>
                <path d="M6120 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M6200 1315 l0 -885 25 0 25 0 0 885 0 885 -25 0 -25 0 0 -885z"/>
                <path d="M6290 1315 l0 -885 80 0 80 0 0 885 0 885 -80 0 -80 0 0 -885z"/>
                <path d="M6500 1315 l0 -885 60 0 60 0 0 885 0 885 -60 0 -60 0 0 -885z"/>
                <path d="M6660 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M6830 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M7000 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M7120 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M7250 1315 l0 -885 60 0 60 0 0 885 0 885 -60 0 -60 0 0 -885z"/>
                <path d="M7450 1315 l0 -885 45 0 45 0 0 885 0 885 -45 0 -45 0 0 -885z"/>
                <path d="M7580 1315 l0 -885 60 0 60 0 0 885 0 885 -60 0 -60 0 0 -885z"/>
                <path d="M7750 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M7870 1315 l0 -885 65 0 65 0 0 885 0 885 -65 0 -65 0 0 -885z"/>
                <path d="M8040 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M8200 1315 l0 -885 25 0 25 0 0 885 0 885 -25 0 -25 0 0 -885z"/>
                <path d="M8330 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M8490 1315 l0 -885 25 0 25 0 0 885 0 885 -25 0 -25 0 0 -885z"/>
                <path d="M8580 1315 l0 -885 60 0 60 0 0 885 0 885 -60 0 -60 0 0 -885z"/>
                <path d="M8740 1315 l0 -885 85 0 85 0 0 885 0 885 -85 0 -85 0 0 -885z"/>
                <path d="M8950 1315 l0 -885 45 0 45 0 0 885 0 885 -45 0 -45 0 0 -885z"/>
                <path d="M9080 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M9200 1315 l0 -885 45 0 45 0 0 885 0 885 -45 0 -45 0 0 -885z"/>
                <path d="M9410 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885 -20
                885 -20 0 -20 -7 -20 -885z"/>
                <path d="M9490 1315 l0 -885 45 0 45 0 0 885 0 885 -45 0 -45 0 0 -885z"/>
                <path d="M9660 1315 l0 -885 65 0 65 0 0 885 0 885 -65 0 -65 0 0 -885z"/>
                <path d="M9870 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M9990 1315 l0 -885 45 0 45 0 0 885 0 885 -45 0 -45 0 0 -885z"/>
                <path d="M10200 1315 l0 -885 45 0 45 0 0 885 0 885 -45 0 -45 0 0 -885z"/>
                <path d="M10330 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885
                -20 885 -20 0 -20 -7 -20 -885z"/>
                <path d="M10410 1315 l0 -885 85 0 85 0 0 885 0 885 -85 0 -85 0 0 -885z"/>
                <path d="M10620 1315 l0 -885 60 0 60 0 0 885 0 885 -60 0 -60 0 0 -885z"/>
                <path d="M10790 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885
                -20 885 -20 0 -20 -7 -20 -885z"/>
                <path d="M10950 1315 l0 -885 45 0 45 0 0 885 0 885 -45 0 -45 0 0 -885z"/>
                <path d="M11120 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885
                -20 885 -20 0 -20 -7 -20 -885z"/>
                <path d="M11240 1315 l0 -885 25 0 25 0 0 885 0 885 -25 0 -25 0 0 -885z"/>
                <path d="M11370 1315 l0 -885 60 0 60 0 0 885 0 885 -60 0 -60 0 0 -885z"/>
                <path d="M11580 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M11700 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885
                -20 885 -20 0 -20 -7 -20 -885z"/>
                <path d="M11830 1315 l0 -885 60 0 60 0 0 885 0 885 -60 0 -60 0 0 -885z"/>
                <path d="M11990 1315 l0 -885 45 0 45 0 0 885 0 885 -45 0 -45 0 0 -885z"/>
                <path d="M12160 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M12330 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885
                -20 885 -20 0 -20 -7 -20 -885z"/>
                <path d="M12450 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885
                -20 885 -20 0 -20 -7 -20 -885z"/>
                <path d="M12620 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885
                -20 885 -20 0 -20 -7 -20 -885z"/>
                <path d="M12700 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885
                -20 885 -20 0 -20 -7 -20 -885z"/>
                <path d="M12870 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M13080 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885
                -20 885 -20 0 -20 -7 -20 -885z"/>
                <path d="M13240 1315 l0 -885 25 0 25 0 0 885 0 885 -25 0 -25 0 0 -885z"/>
                <path d="M13330 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M13540 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885
                -20 885 -20 0 -20 -7 -20 -885z"/>
                <path d="M13700 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885
                -20 885 -20 0 -20 -7 -20 -885z"/>
                <path d="M13870 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M13990 1315 l0 -885 25 0 25 0 0 885 0 885 -25 0 -25 0 0 -885z"/>
                <path d="M14120 1315 l0 -885 60 0 60 0 0 885 0 885 -60 0 -60 0 0 -885z"/>
                <path d="M14330 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M14450 1315 l0 -885 45 0 45 0 0 885 0 885 -45 0 -45 0 0 -885z"/>
                <path d="M14620 1315 l0 -885 60 0 60 0 0 885 0 885 -60 0 -60 0 0 -885z"/>
                <path d="M14830 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885
                -20 885 -20 0 -20 -7 -20 -885z"/>
                <path d="M14910 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M15080 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885
                -20 885 -20 0 -20 -7 -20 -885z"/>
                <path d="M15160 1315 l0 -885 65 0 65 0 0 885 0 885 -65 0 -65 0 0 -885z"/>
                <path d="M15370 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885
                -20 885 -20 0 -20 -7 -20 -885z"/>
                <path d="M15540 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885
                -20 885 -20 0 -20 -7 -20 -885z"/>
                <path d="M15700 1315 l0 -885 45 0 45 0 0 885 0 885 -45 0 -45 0 0 -885z"/>
                <path d="M15830 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M16040 1315 l0 -885 60 0 60 0 0 885 0 885 -60 0 -60 0 0 -885z"/>
                <path d="M16200 1315 c0 -878 0 -885 20 -885 20 0 20 7 20 885 0 878 0 885
                -20 885 -20 0 -20 -7 -20 -885z"/>
                <path d="M16290 1315 l0 -885 40 0 40 0 0 885 0 885 -40 0 -40 0 0 -885z"/>
                <path d="M4318 348 c-17 -33 -22 -60 -22 -113 0 -76 30 -155 59 -155 13 0 11
                8 -7 42 -17 33 -22 60 -22 113 0 53 5 80 22 113 18 34 20 42 7 42 -8 0 -25
                -19 -37 -42z"/>
                <path d="M4902 348 c17 -33 22 -60 22 -113 0 -53 -5 -80 -22 -113 -18 -34 -20
                -42 -7 -42 29 0 59 79 59 155 0 76 -30 155 -59 155 -13 0 -11 -8 7 -42z"/>
                <path d="M8198 348 c-17 -33 -22 -60 -22 -113 0 -76 30 -155 59 -155 13 0 11
                8 -7 42 -17 33 -22 60 -22 113 0 53 5 80 22 113 18 34 20 42 7 42 -8 0 -25
                -19 -37 -42z"/>
                <path d="M8782 348 c17 -33 22 -60 22 -113 0 -53 -5 -80 -22 -113 -18 -34 -20
                -42 -7 -42 29 0 59 79 59 155 0 76 -30 155 -59 155 -13 0 -11 -8 7 -42z"/>
                <path d="M10278 348 c-17 -33 -22 -60 -22 -113 0 -76 30 -155 59 -155 13 0 11
                8 -7 42 -17 33 -22 60 -22 113 0 53 5 80 22 113 18 34 20 42 7 42 -8 0 -25
                -19 -37 -42z"/>
                <path d="M10862 348 c17 -33 22 -60 22 -113 0 -53 -5 -80 -22 -113 -18 -34
                -20 -42 -7 -42 29 0 59 79 59 155 0 76 -30 155 -59 155 -13 0 -11 -8 7 -42z"/>
                <path d="M4467 369 c-45 -26 -61 -136 -29 -199 49 -98 162 -43 162 78 0 101
                -65 160 -133 121z m77 -32 c36 -27 33 -157 -5 -178 -49 -26 -89 15 -89 92 0
                80 45 121 94 86z"/>
                <path d="M4688 373 c-10 -2 -18 -11 -18 -20 0 -11 7 -13 30 -8 l30 7 0 -101 0
                -101 -30 0 c-20 0 -30 -5 -30 -15 0 -12 15 -15 75 -15 60 0 75 3 75 15 0 10
                -10 15 -30 15 l-30 0 0 115 0 115 -27 -1 c-16 -1 -36 -3 -45 -6z"/>
                <path d="M5057 369 c-45 -26 -61 -136 -29 -199 49 -98 162 -43 162 78 0 101
                -65 160 -133 121z m77 -32 c36 -27 33 -157 -5 -178 -49 -26 -89 15 -89 92 0
                80 45 121 94 86z"/>
                <path d="M5277 369 c-45 -26 -61 -136 -29 -199 49 -98 162 -43 162 78 0 101
                -65 160 -133 121z m77 -32 c36 -27 33 -157 -5 -178 -49 -26 -89 15 -89 92 0
                80 45 121 94 86z"/>
                <path d="M5512 364 c-50 -34 -67 -120 -38 -189 37 -89 166 -66 166 30 0 70
                -83 112 -133 68 -20 -18 -20 -17 -13 12 10 45 43 68 88 62 27 -4 38 -1 38 8 0
                28 -72 34 -108 9z m82 -120 c34 -34 9 -94 -39 -94 -30 0 -55 25 -55 55 0 30
                25 55 55 55 13 0 31 -7 39 -16z"/>
                <path d="M5718 373 c-10 -2 -18 -11 -18 -20 0 -11 7 -13 30 -8 l30 7 0 -101 0
                -101 -30 0 c-20 0 -30 -5 -30 -15 0 -12 15 -15 75 -15 60 0 75 3 75 15 0 10
                -10 15 -30 15 l-30 0 0 115 0 115 -27 -1 c-16 -1 -36 -3 -45 -6z"/>
                <path d="M5963 296 c-69 -110 -69 -116 7 -116 l60 0 0 -30 c0 -20 5 -30 15
                -30 10 0 15 10 15 30 0 23 4 30 20 30 11 0 20 7 20 15 0 8 -9 15 -20 15 -18 0
                -20 7 -20 85 0 81 -1 85 -22 85 -18 0 -35 -19 -75 -84z m64 -83 c-3 -2 -23 -3
                -45 -1 l-41 3 42 67 42 67 3 -66 c2 -36 1 -67 -1 -70z"/>
                <path d="M6178 373 c-10 -2 -18 -11 -18 -20 0 -11 7 -13 30 -8 l30 7 0 -101 0
                -101 -30 0 c-20 0 -30 -5 -30 -15 0 -12 15 -15 75 -15 60 0 75 3 75 15 0 10
                -10 15 -30 15 l-30 0 0 115 0 115 -27 -1 c-16 -1 -36 -3 -45 -6z"/>
                <path d="M6413 296 c-69 -110 -69 -116 7 -116 l60 0 0 -30 c0 -20 5 -30 15
                -30 10 0 15 10 15 30 0 23 4 30 20 30 11 0 20 7 20 15 0 8 -9 15 -20 15 -18 0
                -20 7 -20 85 0 81 -1 85 -22 85 -18 0 -35 -19 -75 -84z m64 -83 c-3 -2 -23 -3
                -45 -1 l-41 3 42 67 42 67 3 -66 c2 -36 1 -67 -1 -70z"/>
                <path d="M6628 373 c-10 -2 -18 -11 -18 -20 0 -11 7 -13 30 -8 l30 7 0 -101 0
                -101 -30 0 c-20 0 -30 -5 -30 -15 0 -12 15 -15 75 -15 60 0 75 3 75 15 0 10
                -10 15 -30 15 l-30 0 0 115 0 115 -27 -1 c-16 -1 -36 -3 -45 -6z"/>
                <path d="M6835 355 c-53 -52 -16 -145 56 -145 18 0 41 8 52 18 20 17 20 16 13
                -13 -10 -45 -43 -68 -88 -62 -27 4 -38 1 -38 -8 0 -28 72 -34 108 -9 50 34 67
                120 38 189 -25 59 -97 75 -141 30z m99 -21 c34 -34 9 -94 -39 -94 -49 0 -72
                55 -38 92 20 22 56 23 77 2z"/>
                <path d="M7065 355 c-53 -52 -16 -145 56 -145 18 0 41 8 52 18 20 17 20 16 13
                -13 -10 -45 -43 -68 -88 -62 -27 4 -38 1 -38 -8 0 -28 72 -34 108 -9 50 34 67
                120 38 189 -25 59 -97 75 -141 30z m99 -21 c34 -34 9 -94 -39 -94 -49 0 -72
                55 -38 92 20 22 56 23 77 2z"/>
                <path d="M7285 355 c-53 -52 -16 -145 56 -145 18 0 41 8 52 18 20 17 20 16 13
                -13 -10 -45 -43 -68 -88 -62 -27 4 -38 1 -38 -8 0 -28 72 -34 108 -9 50 34 67
                120 38 189 -25 59 -97 75 -141 30z m99 -21 c34 -34 9 -94 -39 -94 -49 0 -72
                55 -38 92 20 22 56 23 77 2z"/>
                <path d="M7515 355 c-53 -52 -16 -145 56 -145 18 0 41 8 52 18 20 17 20 16 13
                -13 -10 -45 -43 -68 -88 -62 -27 4 -38 1 -38 -8 0 -28 72 -34 108 -9 50 34 67
                120 38 189 -25 59 -97 75 -141 30z m99 -21 c34 -34 9 -94 -39 -94 -49 0 -72
                55 -38 92 20 22 56 23 77 2z"/>
                <path d="M7735 355 c-53 -52 -16 -145 56 -145 18 0 41 8 52 18 20 17 20 16 13
                -13 -10 -45 -43 -68 -88 -62 -27 4 -38 1 -38 -8 0 -28 72 -34 108 -9 50 34 67
                120 38 189 -25 59 -97 75 -141 30z m99 -21 c34 -34 9 -94 -39 -94 -49 0 -72
                55 -38 92 20 22 56 23 77 2z"/>
                <path d="M7992 364 c-50 -34 -67 -120 -38 -189 37 -89 166 -66 166 30 0 70
                -83 112 -133 68 -20 -18 -20 -17 -13 12 10 45 43 68 88 62 27 -4 38 -1 38 8 0
                28 -72 34 -108 9z m82 -120 c34 -34 9 -94 -39 -94 -30 0 -55 25 -55 55 0 30
                25 55 55 55 13 0 31 -7 39 -16z"/>
                <path d="M8338 373 c-10 -2 -18 -11 -18 -20 0 -11 7 -13 30 -8 l30 7 0 -101 0
                -101 -30 0 c-20 0 -30 -5 -30 -15 0 -12 15 -15 75 -15 60 0 75 3 75 15 0 10
                -10 15 -30 15 l-30 0 0 115 0 115 -27 -1 c-16 -1 -36 -3 -45 -6z"/>
                <path d="M8540 365 c0 -12 13 -15 60 -15 33 0 60 -2 60 -4 0 -2 -18 -55 -40
                -116 -33 -92 -37 -111 -23 -108 11 2 31 41 59 118 24 63 43 121 43 128 1 9
                -21 12 -79 12 -64 0 -80 -3 -80 -15z"/>
                <path d="M8923 373 c-7 -2 -13 -11 -13 -18 0 -9 11 -12 39 -8 44 6 81 -10 81
                -35 0 -27 -20 -42 -57 -42 -23 0 -33 -5 -33 -15 0 -10 10 -15 31 -15 62 0 89
                -38 52 -75 -13 -13 -29 -16 -70 -13 -38 3 -53 1 -53 -8 0 -24 75 -33 124 -14
                49 18 61 105 16 117 -18 5 -18 5 1 24 19 19 25 55 11 75 -18 28 -90 43 -129
                27z"/>
                <path d="M9167 369 c-45 -26 -61 -136 -29 -199 49 -98 162 -43 162 78 0 101
                -65 160 -133 121z m77 -32 c36 -27 33 -157 -5 -178 -49 -26 -89 15 -89 92 0
                80 45 121 94 86z"/>
                <path d="M9378 373 c-10 -2 -18 -11 -18 -20 0 -11 7 -13 30 -8 l30 7 0 -101 0
                -101 -30 0 c-20 0 -30 -5 -30 -15 0 -12 15 -15 75 -15 60 0 75 3 75 15 0 10
                -10 15 -30 15 l-30 0 0 115 0 115 -27 -1 c-16 -1 -36 -3 -45 -6z"/>
                <path d="M9593 373 c-7 -2 -13 -13 -13 -22 0 -16 4 -17 39 -8 53 14 91 -2 91
                -38 0 -18 -19 -46 -65 -93 -36 -36 -65 -72 -65 -79 0 -10 21 -13 80 -13 64 0
                80 3 80 15 0 12 -13 15 -57 15 l-57 0 40 43 c82 85 95 129 48 166 -25 20 -89
                27 -121 14z"/>
                <path d="M9823 373 c-7 -2 -13 -11 -13 -18 0 -9 11 -12 39 -8 44 6 81 -10 81
                -35 0 -27 -20 -42 -57 -42 -23 0 -33 -5 -33 -15 0 -10 10 -15 31 -15 62 0 89
                -38 52 -75 -13 -13 -29 -16 -70 -13 -38 3 -53 1 -53 -8 0 -24 75 -33 124 -14
                49 18 61 105 16 117 -18 5 -18 5 1 24 19 19 25 55 11 75 -18 28 -90 43 -129
                27z"/>
                <path d="M10058 373 c-10 -2 -18 -11 -18 -20 0 -11 7 -13 30 -8 l30 7 0 -101
                0 -101 -30 0 c-20 0 -30 -5 -30 -15 0 -12 15 -15 75 -15 60 0 75 3 75 15 0 10
                -10 15 -30 15 l-30 0 0 115 0 115 -27 -1 c-16 -1 -36 -3 -45 -6z"/>
                <path d="M10418 373 c-10 -2 -18 -11 -18 -20 0 -11 7 -13 30 -8 l30 7 0 -101
                0 -101 -30 0 c-20 0 -30 -5 -30 -15 0 -12 15 -15 75 -15 60 0 75 3 75 15 0 10
                -10 15 -30 15 l-30 0 0 115 0 115 -27 -1 c-16 -1 -36 -3 -45 -6z"/>
                <path d="M10657 369 c-45 -26 -61 -136 -29 -199 49 -98 162 -43 162 78 0 101
                -65 160 -133 121z m77 -32 c36 -27 33 -157 -5 -178 -49 -26 -89 15 -89 92 0
                80 45 121 94 86z"/>
                <path d="M11033 348 c-6 -18 -27 -77 -47 -130 -29 -80 -33 -98 -20 -98 9 0 21
                13 27 30 11 29 14 30 73 30 60 0 62 -1 73 -30 5 -17 17 -30 25 -30 13 0 9 19
                -20 98 -20 53 -41 112 -47 130 -7 23 -16 32 -32 32 -16 0 -25 -9 -32 -32z m56
                -68 c12 -30 21 -58 21 -62 0 -5 -20 -8 -45 -8 -25 0 -45 3 -45 6 0 11 43 125
                46 122 1 -2 12 -28 23 -58z"/>
                <path d="M11220 250 l0 -130 64 0 c49 0 69 5 90 21 32 25 35 70 7 98 -17 17
                -18 21 -5 32 20 17 17 66 -6 89 -16 16 -33 20 -85 20 l-65 0 0 -130z m134 78
                c19 -30 -4 -53 -58 -56 l-46 -3 0 41 0 41 46 -3 c31 -2 51 -9 58 -20z m-3 -98
                c11 -6 19 -21 19 -35 0 -30 -26 -45 -79 -45 l-41 0 0 45 0 45 41 0 c22 0 49
                -5 60 -10z"/>
                <path d="M11523 364 c-84 -42 -82 -195 3 -230 62 -26 144 -12 144 25 0 18 -2
                19 -27 5 -74 -38 -153 6 -153 86 0 80 79 124 153 86 25 -14 27 -13 27 5 0 38
                -88 52 -147 23z"/>
                <path d="M11738 373 c-10 -2 -18 -11 -18 -20 0 -11 7 -13 30 -8 l30 7 0 -101
                0 -101 -30 0 c-20 0 -30 -5 -30 -15 0 -12 15 -15 75 -15 60 0 75 3 75 15 0 10
                -10 15 -30 15 l-30 0 0 115 0 115 -27 -1 c-16 -1 -36 -3 -45 -6z"/>
                <path d="M11953 373 c-7 -2 -13 -13 -13 -22 0 -16 4 -17 39 -8 53 14 91 -2 91
                -38 0 -18 -19 -46 -65 -93 -36 -36 -65 -72 -65 -79 0 -10 21 -13 80 -13 64 0
                80 3 80 15 0 12 -13 15 -57 15 l-57 0 40 43 c82 85 95 129 48 166 -25 20 -89
                27 -121 14z"/>
                <path d="M12183 373 c-7 -2 -13 -11 -13 -18 0 -9 11 -12 39 -8 44 6 81 -10 81
                -35 0 -27 -20 -42 -57 -42 -23 0 -33 -5 -33 -15 0 -10 10 -15 31 -15 62 0 89
                -38 52 -75 -13 -13 -29 -16 -70 -13 -38 3 -53 1 -53 -8 0 -24 75 -33 124 -14
                49 18 61 105 16 117 -18 5 -18 5 1 24 19 19 25 55 11 75 -18 28 -90 43 -129
                27z"/>
                </g>

        </SvgIcon>
    );
}

export default BarcodeCode128Svg;
